<template>
    <div class="top-side bgc-theme fc-fff" @mouseleave="showKey = undefined">
        <ul class="flex flex-col align-center side-ul">
            <template v-if="menuSyced">
                <li v-for="item in getHomeSiderBar(basicMenu)" :key="item.showCode"
                    :class="{ 'show-menu-item-hover': showKey === item.name }" @click="openWindow(item.url)"
                    @mouseenter="showKey = item.name">{{ item.name }}</li>
            </template>
        </ul>
        <div v-if="showKey" class="show-menu fc-333">
            <template v-for="(sideInfo, key) in getSideData(basicMenu)">
                <div :key="key" v-if="showKey === key && !['礼品发货', 'API接口'].includes(key)">
                    <div class="flex">
                        <h3 class="fw-bold">{{ key }}</h3>
                        <!-- 卡首屏需要跳转按钮 -->
                        <router-link v-if="showKey === '卡首屏'" to="/head_screen/recommend"
                            style="font-size: 12px; padding-left: 6px; position: relative; top: 6px;">点击查看更多<i
                                class="el-icon-arrow-right" /></router-link>
                    </div>
                    <div v-if="showKey === '用户中心'" class="flex flex-wrap marginT-20">
                        <el-button v-for="(item, index) in getSideData(basicMenu)[key]" :key="item.showCode" type="danger"
                            size="small" @click="$router.push(item.url)">{{ index }}</el-button>
                    </div>
                    <div v-else class="flex flex-wrap marginT-20">
                        <div v-for="(item, index) in getSideData(basicMenu)[key]" @mouseenter="mouseenterHandler(index)"
                            @mouseleave="mouseleaveHandler(index)" :class="{ 'is-active': showBg && index == activeIndex }"
                            @click="$router.push(item.url)" class="item" :key="index">
                            <div class="fs-14 fw-bold point">{{ index }}</div>
                            <el-tag type="danger" v-for="(it, index) in item.tag" :key="index">{{ it }}</el-tag>
                        </div>
                    </div>
                </div>
            </template>
            <div v-if="showKey === '礼品发货'">
                <h3 class="fw-bold">礼品发货</h3>
                <div class="flex flex-wrap marginT-20">
                    <div v-for="(express, index) in wareHouse" class="item" :key="index"
                        @mouseenter="mouseenterHandler(index)" @mouseleave="mouseleaveHandler(index)"
                        @click="$router.push(`/store/list?express=${express.id}`)"
                        :class="{ 'is-active': showBg && index == activeIndex }">
                        <div class="fs-14 fw-bold point" @click="$router.push(`/store/list?express=${express.id}`)">
                            {{ express.express_name }}</div>
                        <el-tag class="point" type="danger" v-for="(item, index) in express.items" :key="index"
                            @click.stop="$router.push(`/store/list?express=${express.id}&ware=${item.custom_warehouse_id}`)">{{
                                item.custom_alias_warehouse_name }}</el-tag>
                    </div>
                </div>
            </div>
            <div v-if="showKey === 'API接口'">
                <h3 class="fw-bold">API接口</h3>
                <div class="flex flex-wrap marginT-20">
                    <div class="fc-666 api-item" v-for="(item, index) in doc" :key="index" @click="pushApi(item)">
                        {{ item.api_name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import sideData from './sideData';
export default {
    props: {
        doc: {
            type: Array,
            default() {
                return []
            }
        },
        wareHouse: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data() {
        return {
            sideData,
            showKey: undefined,
            showBg: false,
            activeIndex: '',
            // showKey: undefined,
        }
    },
    computed: {
        ...mapState(["basicMenu", "menuSyced"])
    },
    methods: {
        goDoc() {
            if (this.isToolMainSite()) {
                return 'http://doc.vv-tool.cn'
            } else {
                return this.configData.proxy_info.site_doc_host
            }
        },
        pushApi(item) {
            window.open(this.goDoc() + '/taobao/' + item.api_code)
        },
        openWindow(url) {
            let urlObj = null
            if (url.indexOf('http') == -1) {
                urlObj = this.$router.resolve({
                    path: url
                })
            } else {
                urlObj = {
                    href: url
                }
            }
            window.open(urlObj.href, '_blank')
        },
        mouseenterHandler(index) {
            this.activeIndex = index;
            this.showBg = true;
        },
        mouseleaveHandler(index) {
            this.activeIndex = index;
            this.showBg = false;
        },

        // 根据 basicMenu 生成侧边数据
        getHomeSiderBar(basicMenu = []) {
            let siderBarArr = [];

            basicMenu.forEach(item => {
                siderBarArr.push({
                    name: item.name,
                    url: item.url,
                    showCode: item.showCode,
                })
            })

            return siderBarArr;
        },

        // 根据 basicMenu 生成内容数据
        getSideData(basicMenu = []) {
            let sideData = {};
            basicMenu.forEach(item => {
                sideData[item.name] = {}
                item.children.forEach(cItem => {
                    sideData[item.name][cItem.name] = {
                        url: cItem.url,
                        tag: cItem.tag
                    }
                })
            })

            return sideData;
        }
    },
}
</script>

<style lang="scss" scoped>
.el-tag {
    height: 24px;
    line-height: 24px;
    padding: 0 4px;
    margin: 2px;
}

.item {
    flex-basis: 140px;
    margin: 4px 8px 8px;
}

.is-active {
    background-color: #eee;
}

.api-item {
    margin: 4px 8px;
    cursor: pointer;
    font-size: 13px;

    &:hover {
        color: #ff6464;
    }
}

.top-side {
    // background: #409EFF;
    margin-right: 10px;
    border-radius: 4px;
    position: relative;
}

.show-menu-item-hover {
    background: #ff9191 !important;
}

.side-ul {
    height: 100%;

    li {
        flex: 1;
        width: 100%;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
    }
}

.show-menu {
    position: absolute;
    padding: 20px;
    box-sizing: border-box;
    left: 170px;
    top: 0px;
    width: 760px;
    min-height: 355px;
    //min-height: 100px;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    background: #fff;
    z-index: 12;
    border: 1px solid #eee;
    overflow: hidden;
}
</style>
